(ns impersonate.views
  (:require
    [very.re-frame.core :as rf]
    [css.core :refer [get-theme defstyled]]
    [css.form :as form]
    [css.typography :as typo]
    [authentication.views :as auth]
    )
  )

(defstyled content-s :div
  {:display "flex"
   :grid-row "body"
   :padding "0 1rem"
   :align-items "center"
   :justify-content "center"
   :flex-direction "column"})

(defn guidebook []
  [auth/unauth-s {:data-test "impersonation-guidebook-unsuccessful"}
   [auth/unauth-header]
   [content-s
    [typo/h1 "Impersonation Unsuccessful"]]
   [auth/unauth-footer]])

(defn advisor []
  [auth/unauth-s {:data-test "impersonation-advisor-unsuccessful"}
   [auth/unauth-header]
   [content-s
    [typo/h1 "Impersonation Unsuccessful"]]
   [auth/unauth-footer]])
